import OwnerSubHeader from "@/components/OwnerSubHeader";
import AdminSites from "@/pages/AdminSites";

export default function SitesPage() {
  return (
    <div className="space-y-5" data-testid="owner-sites-page">
      <OwnerSubHeader title="Manage Sites" subtitle="Locations · Companies · Addresses" />
      <AdminSites />
    </div>
  );
}
